const routes = [
  {
    path: 'databinding',
    name: 'databinding',
    component: () => import(/* webpackChunkName: "databinding" */ '@/modules/databinding/index.vue')
  },
];

export default routes;